<script setup>
import ProfileAvatar from './ProfileAvatar.vue'
import ExitSvg from '@/assets/icons/exit_2.svg'
import InfoTip from '@/components/InfoTip.vue'
import Logo from '@/assets/logo-v3.svg'
import ProgressView from '@/components/profileMenu/ProgressView.vue'
import { useI18n } from 'vue-i18n'
import Accuracy from '@/components/Accuracy.vue'

const { t } = useI18n()

const emit = defineEmits(['logOut'])

const props = defineProps({
  rank: Number,
  rankTitle: String,
  score: Number,
  rankMax: Number
})

const { rank, rankTitle, score, rankMax } = props
</script>

<template>
  <div class="p-4 rounded-lg border-solid gradient-bg shadow-[0_4px_4px_#00000040] w-full">
    <div class="flex gap-3 items-center mb-2">
      <profile-avatar :rank="rank" :size="50" />
      <div class="flex gap-1.5 items-center mb-1 text-xs text-secondary">
        <div class="flex flex-col pl-1">
          <div class="flex gap-1">
            <span class="text-xs font-poppins">Practice Rank</span>
            <info-tip content="Your rank is based on your EV-loss and profitability" />
          </div>
          <div class="text-[#FF7171] text-lg font-poppins">
            <span>{{ rankTitle }}</span>
          </div>
        </div>
      </div>
      <logo class="absolute right-5 top-1 size-10" />
    </div>

    <progress-view :score="score" :rankMax="rankMax" :rank="rank" :textColor="'#FF7171'" />

    <div class="mx-0 h-px bg-white bg-opacity-10 my-4" />

    <div class="flex justify-between items-center px-0">
      <div class="flex gap-1.5 items-center text-xs text-secondary font-poppins">
        <span>Data Accuracy</span>
        <info-tip content="As you play more, the data accuracy improves." />
      </div>
      <div class="flex gap-1.5 items-center text-xs text-white font-poppins">
        <accuracy :type="'Medium'" />
      </div>
    </div>

    <div class="mx-0 h-px bg-white bg-opacity-10 my-4" />

    <button
      class="flex flex-row gap-1 justify-center items-center w-full px-0 text-xs text-secondary cursor-pointer font-poppins"
      @click="emit('logOut')"
    >
      <exit-svg />
      <span>{{ t('button.LogOut') }}</span>
    </button>
  </div>
</template>

<style scoped>
.gradient-bg {
  background: linear-gradient(90deg, #1c1c20 0%, #3c3c47 52.5%, #1c1c20 100%);
}
</style>
